<button
	[type]="type"
	[disabled]="disabled"
	class="btn btn-{{ context }}"
	[class.no-style]="noStyle"
>
	<ng-content></ng-content>
</button>
